export const STRINGS = {
  PAGE_TITLE:
    'Agricultural Solution for Institutional-Buyers | Marketplace Online Portal',
  PAGE_DESCRIPTION:
    'DeHaat marketplace online portal for corporate customers to keep track of transactions, view commodity procurement pipeline and make online orders.',
  PAGE_HEADING: 'Solution For Institutional-Buyers',
  PAGE_SUBHEADING: 'Agri Solution',
  DESCRIPTION:
    'Quantity, quality and availability of farm produce are important factors that have a direct impact on operations of downstream food production companies. Using Data Science, Agri Science and Machine Learning technologies, we have been working on Artificial Intelligence engine that can correlate many of parameters that affect agriculture and provide predictive analytics and early warnings for better production and forecasting mechanism that helps our institutional buyers better plan their operations.\n\nDeHaat Marketplace online portal allows the corporate customers to keep track of transactions, view commodity procurement pipeline and make online orders. We will soon bring in an commodity auction mechanism to our platform as well.',
  DEHAAT_BUSINESS_APP: 'DeHaat-Business APP',
  DEHAAT_FARMER_APP: 'DeHaat-Farmer APP',
  INTERESTED_IN_SERVICE: 'Interested In Our Service ?',
}

export const CONTACT_FORM = {
  ENTER_EMAIL_LABEL: 'Email',
  ENTER_EMAIL_PLACEHOLDER: 'Enter Email',
  ENTER_MESSAGE_LABEL: 'Message',
  ENTER_MESSAGE_PLACEHOLDER: 'Message Here',
  ENTER_NAME_LABEL: 'Name',
  ENTER_NAME_PLACEHOLDER: 'Enter Name',
  PHONE_NUMBER_LABEL: 'Phone Number',
  PHONE_NUMBER_PLACEHOLDER: 'Enter Your Number',
}

export const appList = [
  {
    icon: '/assets/images/farmer',
    alt: STRINGS.DEHAAT_FARMER_APP,
    appName: STRINGS.DEHAAT_FARMER_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=app.intspvt.com.farmer',
  },
  {
    icon: '/assets/images/business-app',
    alt: STRINGS.DEHAAT_BUSINESS_APP,
    appName: STRINGS.DEHAAT_BUSINESS_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=com.intspvt.app.dehaat2',
  },
]
